var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-table',{ref:"table",attrs:{"url":"/catalogClass/get","toolbar":_vm.toolbar,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }